var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIvTrilogyMobile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 114,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37 0h12.333l-37 139.294H0L37 0z",
    fill: "#ADDC9A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M49.334 0h12.333l-37 139.294H12.333L49.334 0z",
    fill: "#6CC04A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M61.666 0H74L37 139.294H24.666L61.666 0z",
    fill: "#2C6D3C"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNzQiIGhlaWdodD0iMTE0IiB2aWV3Qm94PSIwIDAgNzQgMTE0IiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8cGF0aCBkPSJNMzcgMEg0OS4zMzMzTDEyLjMzMzMgMTM5LjI5NEgwTDM3IDBaIiBmaWxsPSIjQUREQzlBIi8+CjxwYXRoIGQ9Ik00OS4zMzM1IDBINjEuNjY2OEwyNC42NjY4IDEzOS4yOTRIMTIuMzMzNUw0OS4zMzM1IDBaIiBmaWxsPSIjNkNDMDRBIi8+CjxwYXRoIGQ9Ik02MS42NjY1IDBINzMuOTk5OEwzNi45OTk4IDEzOS4yOTRIMjQuNjY2NUw2MS42NjY1IDBaIiBmaWxsPSIjMkM2RDNDIi8+Cjwvc3ZnPgo=";
export { SvgIvTrilogyMobile as ReactComponent };